import React, { Component } from 'react'
import Header from '../components/header';
import Footer from '../components/footer';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import davidsons from '../img/logos/davidsons-128x128.jpg'
import rsr from '../img/logos/rsr-128x128.jpg'
import sportsSouth from '../img/logos/sports-south-128x128.jpg'
import zanders from '../img/logos/zanders-128x128.jpg'

class HomeProps { }

class HomeState { }

class Home extends Component<HomeProps, HomeState> {

    render() {
        return (<>
            <Helmet>
                <title>Hawk American Outdoors | Dashboard</title>
            </Helmet>

            <Header />

            <div className="container search">
                <div className="columns">
                    <div className="column has-text-centered">
                        <Link to="/davidsons">
                            <img src={davidsons} width="128" height="128" alt="Davidsons" />
                        </Link>
                    </div>
                    <div className="column has-text-centered">
                        <Link to="/rsr">
                            <img src={rsr} width="128" height="128" alt="RSR" />
                        </Link>
                    </div>
                    <div className="column has-text-centered">
                        <Link to="/sports-south">
                            <img src={sportsSouth} width="128" height="128" alt="Sports South" />
                        </Link>
                    </div>
                    <div className="column has-text-centered">
                        <Link to="/zanders">
                            <img src={zanders} width="128" height="128" alt="Zanders" />
                        </Link>
                    </div>
                </div>
            </div>

            <Footer />
        </>);
    }
}

export default Home
